module.exports = __webpack_public_path__ + "static/img/detail_elebits-microsite_02.e59536c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/elebits-web-development/detail_elebits-microsite_02.jpg
// module id = 236
// module chunks = 2